import React, { createContext } from "react";

import { defaultTimeZone, TimeZone } from "./DateRenderProvider";

export const DateRenderContext = createContext<{
    renderDate: (date: Date) => string;
    renderDateTime: (date: Date) => string;
    timeZone: TimeZone;
    setTimeZone: (format: TimeZone) => void;
}>({
    renderDate: () => "",
    renderDateTime: () => "",
    timeZone: defaultTimeZone,
    setTimeZone: () => {}
});
